import {
    put, putResolve,
} from 'redux-saga/effects'

import {
    REQUEST,
} from 'piconetworks/pkg-network-middleware'
import {
    PICO_API_URL,
    AUTH_USER_CODE_CONFIRM,
} from 'piconetworks/pkg-endpoints'

function* confirmOneTimeCode({
    code,
    customProperties,
    email,
    newsletters,
    origin,
    phone,
    popupId,
    publisherId,
    is_login,
    referer,
    types,
    utm,
}) {
    try {
        const { data } = yield putResolve({
            type: REQUEST,
            config: {
                method: 'post',
                baseURL: PICO_API_URL(),
                url: AUTH_USER_CODE_CONFIRM(),
                params: {
                    ...(!!utm && { utm }),
                },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    publisherid: publisherId,
                    ...(!!referer && { 'prev-page': referer }),
                    ...(!!origin && { 'current-url': origin }),
                },
                timeout: 30000,
                data: {
                    code,
                    email,
                    form_id: popupId,
                    newsletter_ids: newsletters,
                    custom_properties: customProperties,
                    is_login,
                    phone,
                },
            },
        })

        yield put({
            type: types.CONFIRM_ONE_TIME_CODE_SUCCESS,
            payload: {
                ...data,
            },
        })

    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            yield put({
                type: types.CONFIRM_ONE_TIME_CODE_ERROR,
                error: {
                    message: error.response.data.message,
                    verify_flow_id: error.response.data.errors.verify_flow_id
                },
            })
        } else {
            yield put({
                type: types.CONFIRM_ONE_TIME_CODE_ERROR,
                error: {
                    message: error.message,
                    verify_flow_id: error.errors.verify_flow_id
                },
            })
        }
    }
}

export default confirmOneTimeCode
